import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { FullProps } from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';
import { BackendAdvancedPlayerSearch } from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';
import { scoutingCenterBackendMarketDropdownFilters } from '@sorare/marketplace/src/searchCommonPlayer/filtersGroup/football';

type Props = Omit<FullProps, 'sport' | 'dropdownFilters'>;

export const FootballPlayerSearch = (props: Props) => (
  <BackendAdvancedPlayerSearch
    sport={Sport.FOOTBALL}
    defaultHitsPerPage={20}
    {...props}
    dropdownFilters={scoutingCenterBackendMarketDropdownFilters}
  />
);
